module.exports = __webpack_public_path__ + "static/media/a2r-groove.2f5d986a.png";